import { adminConstants } from '../constant/admin-constant';

const initialState = {
    loading: false,
    list: {},
    list_types: {
        result: {
            lists: {
                data: []
            }
        }
    },
    childrens: []
    // childrens: action.payload.result.list.childrens
};
export function listReducer(state = initialState, action) {

    switch (action.type) {

        case adminConstants.PAGINATION_LIST_REQUEST:
            return { ...state, loading: true, listData: {}, editListItem: '', storedCountry: '', updatedListItem: '', deleteListItem: false };
        case adminConstants.PAGINATION_LIST_SUCCESS:
            return { ...state, countries: action.payload.countries.data, pages: action.payload.countries.last_page, loading: false, current_page: action.payload.countries.current_page };
        case adminConstants.PAGINATION_LIST_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.GET_LIST_REQUEST:
            return { ...state, loading: true };
        case adminConstants.GET_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                current_page: action.payload.result.list_type_listing.current_page,
                pages: action.payload.result.list_type_listing.last_page,
                [action.payload.result.component_name]: action.payload.result.list_type_listing.data,
                list_type_name: action.payload.result.list_type,
            };
        case adminConstants.GET_LIST_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.GET_LIST_ITEM_REQUEST:
            return { ...state, loading: true };
        case adminConstants.GET_LIST_ITEM_SUCCESS:
            return { ...state, loading: false, listItem: action.payload.result, childrens: (action.payload.result.list !== undefined && action.payload.result.list.childrens) ? action.payload.result.list.childrens : [] };
        case adminConstants.GET_LIST_ITEM_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.STORE_LIST_ITEM_REQUEST:
            return { ...state, loading: true, editList: '', storedListItem: '' }
        case adminConstants.STORE_LIST_ITEM_SUCCESS:
            return { ...state, loading: false, storedListItem: action.payload.list };
        case adminConstants.STORE_LIST_ITEM_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.EDIT_LIST_ITEM_REQUEST:
            return { ...state, loading: true, updatedListItem: '' };
        case adminConstants.EDIT_LIST_ITEM_SUCCESS:
            return { ...state, loading: false, updatedListItem: action.payload.list };
        case adminConstants.EDIT_LIST_ITEM_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.DELETE_LIST_ITEM_REQUEST:
            return { ...state, loading: true, deleteListItem: false }
        case adminConstants.DELETE_LIST_ITEM_SUCCESS:
            return { ...state, loading: false, deleteListItem: true };
        case adminConstants.DELETE_LIST_ITEM_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case adminConstants.GET_ALL_LIST_TYPES_PARENT_REQUEST:
            return { ...state, loading: true };
        case adminConstants.GET_ALL_LIST_TYPES_PARENT_SUCCESS:
            return { ...state, loading: false, listItempParent: action.payload.result.listing };
        case adminConstants.GET_ALL_LIST_TYPES_PARENT_FAILURE:
            return { ...state, loading: false, error: action.payload };

        default:
            return { ...state };
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/ListReducer.jsx